export default __webpack_public_path__ + "c6938660eec019fefd684894b6d00900.woff";